export const CompanyLabel = "Company";
export const AddCompanyLabel = "Add Company";
export const id = "id";
export const Company_Name = "company_name";
export const Name = "Name";
export const Company_Country = "company_country";
export const Country = "Country";
export const Company_Address = "company_address";
export const Address = "Address";
export const Actions = "Actions";
export const Contactlink = "Contact Link";
export const NewTab = "_blank";
export const EditCompany = "Edit Company";
export const SearchCompany = "Search Company";
export const Update = "Update";
export const Submit = "Submit";
export const CompanyCountry = "Company Country";
export const CompanyAddress = "Company Address";
export const Contact_Link = "contact_link";
export const DeleteCompany = "Delete Company";
export const Delete = "Delete";
export const DeleteConfirmation =
  "Are you sure you want to delete this company?";
export const Remarks = "Remarks";
export const Email = "Email";
export const Contact_No = "Contact Number";
export const Company_Email = "email";
export const Company_Contact = "contact_no";
export const Company_Remarks = "remarks";
export const Contact = "Contact";
